export default "__VITE_ASSET__9c5a21ef__"